import React from 'react';

import { SearchButtonContainer } from '../Search/SearchButton';
import { RegionsButtonContainer } from '../Regions/RegionsButton';
import { SearchAndRegionsButtonsLayout } from '../../components/SearchAndRegionsButtonsLayout';
import { PageHeaderLayout } from '../../components/PageHeaderLayout';

/**
 * Шапка страницы по умолчанию
 */
export const PageHeaderContainer = () => (
  <PageHeaderLayout>
    <SearchAndRegionsButtonsLayout>
      <SearchButtonContainer />
      <RegionsButtonContainer />
    </SearchAndRegionsButtonsLayout>
  </PageHeaderLayout>
);
